import React, { useCallback, useEffect, useRef, useState } from "react";
import cx from "classnames";
import styles from "./Toggle.module.scss";
import { Speed } from "./Dynamic";

interface Props {
  open?: boolean;
  children: React.ReactNode;
  speed?: Speed;
}

export const Toggle: React.FunctionComponent<Props> = ({
  open = false,
  children,
  speed = Speed.FAST,
}) => {
  const toggleRef = useRef<HTMLDivElement>(null);
  const [animationStyle, setAnimationStyle] = useState<boolean>(false);

  const onTransitionEnd = useCallback(
    (ev: TransitionEvent) => {
      if (!(ev.target as HTMLElement).classList.contains(styles.toggle)) {
        return;
      }

      if (ev.propertyName !== "height") {
        return;
      }

      setAnimationStyle(!open);
    },
    [open]
  );

  useEffect(() => {
    if (!toggleRef.current) {
      return;
    }
    const ref = toggleRef.current;
    ref.addEventListener("transitionend", onTransitionEnd);

    return () => {
      ref.removeEventListener("transitionend", onTransitionEnd);
    };
  }, [onTransitionEnd]);

  return (
    <div
      ref={toggleRef}
      className={cx(styles.toggle, styles[`speed-${speed}`], {
        [styles.open]: open,
        [styles.on]: animationStyle,
      })}
    >
      {children}
    </div>
  );
};
